module.exports = __webpack_public_path__ + "static/media/pedidoConfirmado.0525b687.png";